webpackJsonp([195850678278728],{

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.tagPageQuery = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(49);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactHelmet = __webpack_require__(51);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Page = __webpack_require__(27);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TagsPage = function TagsPage(_ref) {
		var _ref$data = _ref.data,
		    group = _ref$data.allMarkdownRemark.group,
		    title = _ref$data.site.siteMetadata.title,
		    pageBG = _ref$data.pageBG;
		return _react2.default.createElement(
			_Page2.default,
			{
				title: 'Total ' + group.length + ' tags',
				subtitle: title,
				hero: pageBG.childImageSharp
			},
			_react2.default.createElement(
				_reactHelmet2.default,
				null,
				_react2.default.createElement(
					'title',
					null,
					'Tags | ' + title
				)
			),
			_react2.default.createElement(
				'div',
				{
					className: 'tags',
					style: { maxWidth: '960px', margin: '2rem auto' }
				},
				group.map(function (tag) {
					return _react2.default.createElement(
						_gatsbyLink2.default,
						{
							className: 'tag is-info is-large',
							to: '/tags/' + (0, _lodash2.default)(tag.fieldValue) + '/',
							key: tag.fieldValue
						},
						tag.fieldValue,
						' (',
						tag.totalCount,
						')'
					);
				})
			)
		);
	};
	TagsPage.propTypes = {
		data: _propTypes2.default.shape({
			allMarkdownRemark: _propTypes2.default.object,
			site: _propTypes2.default.object,
			pageBG: _propTypes2.default.shape({
				childImageSharp: _propTypes2.default.object.isRequired
			})
		}).isRequired
	};
	
	exports.default = TagsPage;
	var tagPageQuery = exports.tagPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tags-js-6ef362cb4e92e7718a67.js